import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    height: 0,
  },
  reducers: {
    setHeaderHeight: (state, action) => {
      state.height = action.payload;
    },
  },
});

export const { setHeaderHeight } = headerSlice.actions;

export default headerSlice.reducer;
